// React Router keeps the window's scroll position across navigations, so a new
// screen has to be put at its top explicitly.
//
// The key is what counts as a screen: the section plus the record. Switching tabs
// within a record ("/routes/:id/logs" → "/routes/:id/sources") stays on one
// screen, and resetting the scroll there fights the sticky tab strip.
export const scrollAnchorKey = (pathname: string): string => {
  const segments = pathname.split('/').filter(Boolean);
  // The creation wizards are the exception: "/routes/new" and
  // "/routes/new/configureprovider/:type" are two screens, not a record and
  // its tabs.
  const depth = segments[1] === 'new' ? 3 : 2;
  return segments.slice(0, depth).join('/');
};
